/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React from "react";
import { Card, Col } from "antd";
import { FileTextOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import next_arrow from "../../../../assests/images/master/next-arrow.svg";
import Heading from "../../../../components/Heading";
import constants from "../../../../constants/constants";
import report from "../../../../assests/images/SVG/report-img.svg";
import booking_vs_audited from "../../../../assests/images/reportSvg/BookingVsAudited.svg";
import booking_vs_status from "../../../../assests/images/reportSvg/BookingVsStatus.png";
import booking_vs_inscan_outscan from "../../../../assests/images/reportSvg/bookingVsInscanOutscanReport.svg";
import e_way_bill from "../../../../assests/images/reportSvg/ewayBillreport.svg";
import hub_audit_entry from "../../../../assests/images/reportSvg/hubAuditEntryReport.svg";
import incoming_bags from "../../../../assests/images/reportSvg/incomingBags.svg";
import incoming_lcr_bag from "../../../../assests/images/reportSvg/incomingLcrBag.svg";
import incoming_shipments from "../../../../assests/images/reportSvg/incomingShipment.svg";
import offload_report from "../../../../assests/images/reportSvg/offloadReport.svg";
import outscan_bag from "../../../../assests/images/reportSvg/outscanBags.svg";
import outscan_lcr_bags from "../../../../assests/images/reportSvg/outscanLcrBags.svg";
import outscan_lcr_shipments from "../../../../assests/images/reportSvg/outscanLcrShipment.svg";
import wrong_sorting_reports from "../../../../assests/images/reportSvg/wrongSoting.svg";
import shipments_inscan_vs_outscan from "../../../../assests/images/reportSvg/shipmentInscanVsOutscanReport.svg";
import outscan_shipments from "../../../../assests/images/reportSvg/outscanShipment.svg";

const { ROLES } = constants;
const { CP_ADMIN, HO_ADMIN, HUB_ADMIN, ROLE_HOMARKETING, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD,ROLE_CENTRALOPERATOR,ROLE_HUBOPERATOR } = ROLES;


const ReportTiles = () => {
    const navigate = useNavigate();
    const hubDetails = JSON.parse(localStorage.getItem("userId"));
    const hubRole = JSON.parse(localStorage.getItem("userinfo"));

    const handleNavigation = (report) => {
        navigate("/all_reports", { state: { embeddedId: report.embeddedId, rsl: report.rls } });
    };
    const reports = [
        // {
        //     id: 1, name: "Booking vs Audited Report", embeddedId: "2816171b-9d99-4555-bc03-d8b720a38fca",icon: booking_vs_audited, rls: [{
        //         clause: `Hub_name = '${hubDetails.premises.premiseName}'`,
        //         dataset: 833
        //     }], role: [HUB_ADMIN]
        // },
        // {
        //     id: 2, name: "Booking Data vs Status Report", embeddedId: "6e8d8294-a209-487f-bff8-da8ae08ed5f3", icon: booking_vs_status, rls: [{
        //         clause: `From_hub = '${hubDetails.premises.premiseName}'`,
        //         dataset: 840
        //     }], role: [HUB_ADMIN]
        // },
        // {
        //     id: 3, name: "Booking vs InScan OutScan Report", embeddedId: "85cfdc8e-16f3-44c5-bc5d-8c1c20333bd8", icon: booking_vs_inscan_outscan, rls: [{
        //         clause: `To_hub = '${hubDetails.premises.premiseName}'`,
        //         dataset: 834
        //     }], role: [HUB_ADMIN]
        // },
        // {
        //     id: 4, name: "E-way Bill report", embeddedId: "a988352d-3d84-4195-9b08-98a9812e2809", icon: e_way_bill, rls: [
        //         {
        //             clause: `Parent_hub = '${hubDetails.premises.premiseName}'`,
        //             dataset: 832
        //         }
        //     ], role: [HUB_ADMIN]
        // },
        // {
        //     id: 5, name: "Hub Audit Entry Report", embeddedId: "e75c602c-d12f-4df4-a686-c392fc2ae11d", icon: hub_audit_entry, rls: [
        //         {
        //             clause: `Audited_hub = '${hubDetails.premises.premiseName}'`,
        //             dataset: 839
        //         }
        //     ], role: [HUB_ADMIN]
        // },
        // {
        //     id: 6, name: "Incoming Bags", embeddedId: "52057965-93aa-4214-bbc2-b432cb023092", icon: incoming_bags, rls: [{
        //         clause: `To_hub = '${hubDetails.premises.premiseName}'`,
        //         dataset: 828
        //     }], role: [HUB_ADMIN]
        // },
        // {
        //     id: 7, name: "Incoming LCR Bag", embeddedId: "df01e2f8-e85e-4710-ba2c-cd73cc28628c", icon: incoming_lcr_bag, rls: [{
        //         clause: `To_hub = '${hubDetails.premises.premiseName}'`,
        //         dataset: 823
        //     }], role: [HUB_ADMIN]
        // },
        // {
        //     id: 8, name: "Incoming Shipments", embeddedId: "b67bbba2-e546-4e20-8c98-2f59c24527d0", icon: incoming_shipments, rls: [
        //         {
        //             clause: `To_Hub = '${hubDetails.premises.premiseName}'`,
        //             dataset: 917
        //         }
        //     ], role: [HUB_ADMIN]
        // },
           { id: 9, name: "Offload Report", embeddedId: "cf3072c6-516c-4634-bc0f-5fd732de39c7", icon: offload_report, rls: [], role: [HUB_ADMIN,ROLE_CENTRALOPERATOR,ROLE_HUBOPERATOR] },
        // {
        //     id: 10, name: "OutScan Bag", embeddedId: "82a353df-31fb-43b8-b3b4-f1fdf6630bf4", icon: outscan_bag, rls: [{
        //         clause: `From_hub = '${hubDetails.premises.premiseName}'`,
        //         dataset: 919
        //     }], role: [HUB_ADMIN]
        // },
        // {
        //     id: 11, name: "OutScan LCR Bags", embeddedId: "12472d34-62bc-45c8-982c-4612a8fa1948", icon: outscan_lcr_bags, rls: [{
        //         clause: `From_hub = '${hubDetails.premises.premiseName}'`,
        //         dataset: 825
        //     }], role: [HUB_ADMIN]
        // },
        // {
        //     id: 12, name: "OutScan LCR Shipments", embeddedId: "940e6f7a-f8d4-4ad4-b3ce-34aa38e4b37d", icon: outscan_lcr_shipments, rls: [{
        //         clause: `from_hub = '${hubDetails.premises.premiseName}'`,
        //         dataset: 915
        //     }], role: [HUB_ADMIN,ROLE_HUBOPERATOR]
        // },
        // {
        //     id: 13, name: "OutScan Shipments", embeddedId: "22ffbade-0f8f-458d-ad80-e60cc9450b18", icon: outscan_shipments, rls: [{
        //         clause: `From_Hub = '${hubDetails.premises.premiseName}'`,
        //         dataset: 916
        //     }], role: [HUB_ADMIN]
        // },
        // {
        //     id: 14, name: "Wrong Sorting Reports", embeddedId: "75d277cb-ce51-4ff0-8e1f-e574b83390e6", icon: wrong_sorting_reports, rls: [{
        //         clause: `From_hub = '${hubDetails.premises.premiseName}'`,
        //         dataset: 841
        //     }], role: [HUB_ADMIN,ROLE_HUBOPERATOR]
        // },
        // {
        //     id: 15, name: "Shipments InScan vs OutScan Report", embeddedId: "a04ecebe-10af-4aef-b8d7-4c0a7128a421", icon: shipments_inscan_vs_outscan, rls: [{
        //         clause: `Hub = '${hubDetails.premises.premiseName}'`,
        //         dataset: 910
        //     }], role: [HUB_ADMIN]
        // },
        // {
        //     id: 16, name: "VayuQuick/Pro-Booking", embeddedId: "aab9f47c-c199-4af8-854a-f771231034bd", icon: report, rls: [{
        //         clause: `Booking_hub = '${hubDetails.premises.premiseName}'`,
        //         dataset: 1044
        //     }], role: [HUB_ADMIN]
        // },
        {
            id: 25, name: "VayuQuick/Pro-Delivery", embeddedId: "aab9f47c-c199-4af8-854a-f771231034bd", icon: report, rls: [{
                clause: `Destination_hub = '${hubDetails.premises.premiseName}'`,
                dataset: 1044
            }], role: [HUB_ADMIN]
        },
        {
            id: 17, name: "Vayu Quick Dashboard ", embeddedId: "819700ee-f853-4ca2-bd43-1fd0a39c4ff7",icon: report ,rls: [], role: [ROLE_FUNCTIONALHEAD,ROLE_MD]
        },
        // {
        //     id: 18, name: "Delivery MIS Report", embeddedId: "7f5c75d9-e1e6-4afc-8fa0-ac46020aedef", icon: report, rls: [], role: [HO_ADMIN,ROLE_ZONALHEAD,ROLE_ZONALOPERATOR,ROLE_RM,ROLE_FUNCTIONALHEAD]
        // },
        {
            id: 19, name: "Booking Report", embeddedId: "176169e5-5642-47e8-9f8d-099a7d2c5d55", icon: report, rls: [], role: [HO_ADMIN,ROLE_FUNCTIONALHEAD,ROLE_RM,ROLE_CENTRALOPERATOR]
        },
        // {
        //     id: 20, name: "Delivery MIS Report", embeddedId: "7f5c75d9-e1e6-4afc-8fa0-ac46020aedef", icon: report, rls: [{
        //         clause: `delivery_hub = '${hubDetails.premises.premiseName}'`,
        //         dataset: 992
        //     }], role: [HUB_ADMIN]
        // },
        {
            id: 21, name: "Control Tower Dashboard", embeddedId: "e8e73567-9a1d-46a4-801f-2554a63180af", icon: report, rls: [], role: [HO_ADMIN,ROLE_FUNCTIONALHEAD]
        },
        {
            id: 22, name: "Pincode Active/InActive Timeline", embeddedId: "e48255de-0cb3-41ec-9ed3-c5f905a22346", icon: report, rls: [], role: [ROLE_FUNCTIONALHEAD]
        },
        // {
        //     id: 23, name: "Shipments Inscanned", embeddedId: "2401fae2-ed93-4143-a608-196dfa123d32", icon: report, rls: [{
        //         clause: `hub = '${hubDetails.premises.premiseName}'`,
        //         dataset: 1029
        //     }], role: [HO_ADMIN,HUB_ADMIN]
        // },
        // {
        //     id: 24, name: "Shipments Outscanned", embeddedId: "d37a805b-d210-40d3-8b6a-8e67f1f6a96e", icon: report, rls: [{
        //         clause: `hub = '${hubDetails.premises.premiseName}'`,
        //         dataset:1028
        //     }], role: [HO_ADMIN,HUB_ADMIN]
        // },
        //All Reports Without Filter

        // {
        //     id: 25, name: "E-way Bill report", embeddedId: "a988352d-3d84-4195-9b08-98a9812e2809", icon: e_way_bill, rls: [], role: [ROLE_MD,ROLE_CENTRALOPERATOR,ROLE_FUNCTIONALHEAD]
        // },
        // {
        //     id: 26, name: "Incoming LCR Bag", embeddedId: "df01e2f8-e85e-4710-ba2c-cd73cc28628c", icon: incoming_lcr_bag, rls: [], role: [ROLE_MD,ROLE_CENTRALOPERATOR,ROLE_FUNCTIONALHEAD]
        // },
        // {
        //     id: 27, name: "Incoming Shipments", embeddedId: "b67bbba2-e546-4e20-8c98-2f59c24527d0", icon: incoming_shipments, rls: [], role: [ROLE_MD,ROLE_CENTRALOPERATOR,ROLE_FUNCTIONALHEAD]
        // },
        // {
        //     id: 28, name: "OutScan LCR Bags", embeddedId: "12472d34-62bc-45c8-982c-4612a8fa1948", icon: outscan_lcr_bags, rls: [], role: [ROLE_MD,ROLE_CENTRALOPERATOR,ROLE_FUNCTIONALHEAD]
        // },
        // {
        //     id: 29, name: "OutScan Bag", embeddedId: "82a353df-31fb-43b8-b3b4-f1fdf6630bf4", icon: outscan_bag, rls: [], role: [ROLE_MD,ROLE_CENTRALOPERATOR,ROLE_FUNCTIONALHEAD]
        // },
        // {
        //     id: 30, name: "OutScan Shipments", embeddedId: "22ffbade-0f8f-458d-ad80-e60cc9450b18", icon: outscan_shipments, rls: [], role: [ROLE_MD,ROLE_CENTRALOPERATOR,ROLE_FUNCTIONALHEAD]
        // },
        // {
        //     id: 32, name: "OutScan LCR Shipments", embeddedId: "940e6f7a-f8d4-4ad4-b3ce-34aa38e4b37d", icon: outscan_lcr_shipments, rls: [], role: [ROLE_CENTRALOPERATOR]
        // },
        // {
        //     id: 33, name: "Wrong Sorting Reports", embeddedId: "75d277cb-ce51-4ff0-8e1f-e574b83390e6", icon: wrong_sorting_reports, rls: [], role: [ROLE_CENTRALOPERATOR]
        // },
        // {
        //     id: 34, name: "Shipments InScan vs OutScan Report", embeddedId: "a04ecebe-10af-4aef-b8d7-4c0a7128a421", icon: shipments_inscan_vs_outscan, rls: [], role: [ROLE_CENTRALOPERATOR]
        // },
        // {
        //     id: 35, name: "VayuQuick/Pro-Booking", embeddedId: "aab9f47c-c199-4af8-854a-f771231034bd", icon: report, rls: [], role: [ROLE_CENTRALOPERATOR]
        // },
        {
            id: 36, name: "VayuQuick/Pro-Delivery", embeddedId: "aab9f47c-c199-4af8-854a-f771231034bd", icon: report, rls: [], role: [ROLE_CENTRALOPERATOR]
        },
        
        {
            id: 31, name: "TAT Analysis", embeddedId: "6b6abbda-2f74-4b40-a25f-e6f8527300aa", icon: report, rls: [], role: [ROLE_MD,ROLE_FUNCTIONALHEAD]
        }
        
        
    ];
    return (
        <Card className="hub-cp-container" style={{ background: "transparent", boxShadow: "none", border: "none" }}>
            <Heading title="All Reports" />
            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", padding: "6px" }}>
                {reports
                    .filter((report) => report.role.includes(hubRole?.roles[0])) // Filter reports based on role
                    .map((report) => (
                        <Col
                            xs={24} sm={12} md={8} lg={6} xl={4}
                            key={report.id}
                            onClick={() => handleNavigation(report)}
                            className="pointer master-card-col"
                        >
                            <div className="master-card-container">
                                <div className="img-wrapper">
                                    {report.icon ? <img src={report.icon} alt="report" /> : <FileTextOutlined style={{ fontSize: "40px", color: "#1890ff" }} />}
                                </div>
                                <div className="div">
                                    {report.name}&nbsp;<img src={next_arrow} alt="Next" />
                                </div>
                            </div>
                        </Col>
                    ))}
            </div>
        </Card>
    );
};

export default ReportTiles;
